import {SiteModel} from './site.model';

export class UserModel {
  constructor(
    public password?: string,
    public username?: string,
    public email?: string,
    public userId?: number,
    public role?: string,
    public primarySiteId?: number,
    public phoneNum?: string,
    public name?: string,
    public associatedSites?: SiteModel[],
    public expiryDate?: string,
    public userTypeId?: number,
    public userType?: string,
    public serverId?: number,
    public id?: number,

  ) {

  }
}
